import Vue from 'Vue'

const eventBus = new Vue()

export { eventBus }



// WEBPACK FOOTER //
// ./src/utils/eventBus.js